import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchContentItemByUrl } from './../../ui/src/actions.js';
import { fetchSectionDetail } from './../actions.js';
import { trimSlashes, getProp } from './../../ui/src/utilities.js';
import ForOFor from './../container/forOFor';
import SectionContentItem from './sectionContentItem';
import { Spinner } from './../../ui/src/component/spinner';
import ArticleContentItem from './articleContentItem';
import { NotFoundError } from '../../ui/src/errors';

class ContentItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pathname: trimSlashes(this.props.location.pathname),
    };
  }

  componentDidMount() {
    ContentItem.fetchContentItem(
      this.props.dispatch,
      this.state.pathname,
    ).catch(e => {
      // catch
    });
  }

  componentWillReceiveProps(nextProps) {
    if (trimSlashes(nextProps.location.pathname) !== this.state.pathname) {
      this.setState(
        { pathname: trimSlashes(nextProps.location.pathname) },
        () => {
          ContentItem.fetchContentItem(
            this.props.dispatch,
            this.state.pathname,
          ).catch(e => {
            // catch
          });
        },
      );
    }
  }

  static fetchContentItem(dispatch, url) {
    return dispatch(
      fetchContentItemByUrl(process.env.REACT_APP_CONTENT_SPACE, url),
    )
      .then(response => {
        if (getProp(response, 'urltype') === 'redirect') {
          if (typeof window !== 'undefined') {
            window.location.href = `/${trimSlashes(response.object_id)}`;
          }
          return;
        }
        return response;
      })
      .catch(e => {});
  }

  render() {
    const contentItem = this.props.contentItems.byUrl[this.state.pathname];
    if (!contentItem) {
      // ak nemame content item, je mozne ze sa nenasiel, ale takisto je mozne, ze sa este nacitava
      if (!this.props.contentItems.isFetching) {
        // ak nemam content a zaroven skoncilo nacitavanie, je jasne, ze stranka neexistuje
        return <ForOFor />;
      }
      return <Spinner show={true} />;
    }

    if (contentItem.urltype === 'article') {
      return (
        <ArticleContentItem
          id={this.props.articles.byUrl[this.state.pathname]}
        />
      );
    } else if (contentItem.urltype === 'section') {
      return (
        <SectionContentItem
          id={this.props.sections.byUrl[this.state.pathname]}
          locationId={getProp(this.props, 'location.query.lokalita', null)}
        />
      );
    }
    return null;
  }
}

ContentItem.fetchData = ({ store, renderProps: { location } }) => {
  if (location)
    return ContentItem.fetchContentItem(
      store.dispatch,
      trimSlashes(location.pathname),
    )
      .then(() => {
        const contentItem = store.getState().contentItems.byUrl[
          trimSlashes(location.pathname)
        ];
        if (contentItem.urltype === 'section') {
          return store.dispatch(
            fetchSectionDetail(
              store.getState().sections.byUrl[trimSlashes(location.pathname)],
            ),
          );
        }
      })
      .catch(() => {
        throw new NotFoundError();
        // zrejme sa nenasiel content item, pohoda, zobrazime 404
      });
};

ContentItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  contentItems: PropTypes.object.isRequired,
  sections: PropTypes.object.isRequired,
  articles: PropTypes.object.isRequired,
};

ContentItem.__name = 'ContentItem';

export default connect(state => {
  return {
    contentItems: state.contentItems,
    sections: state.sections,
    articles: state.articles,
  };
})(ContentItem);



// WEBPACK FOOTER //
// ./src/app/container/contentItem.js